/* @flow */

import React from 'react';
import { pure } from 'recompose';
import { style, media } from 'glamor';

import FocusTrap from 'react-focus-trap';

class ModalShell extends React.Component {
  props: {
    children: React.Element,
    closePortal: () => void,
    next: ?() => void,
    previous: ?() => void,
  };

  state: {
    isOpen: boolean,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      document.body.classList.add('modal-open');
    }
    setTimeout(() => {
      this.setState({isOpen: true});
    }, 4);
  }

  componentWillUnmount() {
    if (typeof window !== undefined) {
      document.body.classList.remove('modal-open');
    }
  }

  setWrapperRef = el => {
    this._wrapper = el;
  }

  close = (): void => {
    const { closePortal } = this.props;
    this.setState({isOpen: false});
    setTimeout(() => {
      closePortal();
    }, 200);
  };

  handleCloseClick = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    this.close();
  }

  render() {
    const { children } = this.props;
    const { isOpen } = this.state;

    const wrapperStyles = {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      opacity: '0',
      backgroundColor: 'rgba(0, 0, 0, .5)',
      WebkitOverflowScrolling: 'touch',
      transition: 'opacity .1s ease-in-out',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: '1000',
      overflow: 'hidden',
    };

    const openWrapperStyles = {
      ...wrapperStyles,
      opacity: '1',
    };

    const rootStyles = {
      width: '400px',
      position: 'relative',
      WebkitOverflowScrolling: 'touch',
      display: 'flex',
      cursor: 'default',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 100px 0 rgba(0, 0, 0, .25)',
      transition: `
        transform .1s ease-in-out,
        opacity .1s ease-in-out,
        margin .05s ease-in-out,
        max-width .1s ease-in-out,
        min-height .1s ease-in-out`,
      opacity: '0',
      transform: 'scale(0)',
    };

    const openRootStyles = {
      ...rootStyles,
      transform: 'scale(1)',
      opacity: '1',
    };

    return (
      <div
        ref={this.setWrapperRef}
        {...style(isOpen ? openWrapperStyles : wrapperStyles)}
        {...media('(max-width: 700px)', {
          position: 'absolute',
          height: '100vh',
        })}
      >
        <div
          onClick={this.close}
          {...style({
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
          })}
          {...media('(max-width: 700px)', {
            position: 'absolute',
          })}
        />
        <div
          {...style(isOpen ? openRootStyles : rootStyles)}
          {...media('(max-width: 700px)', {
            width: '100%',
            height: '100%',
          })}
        >
          <FocusTrap>
            <div {...style({
              width: '100%',
              height: '100%',
              backgroundColor: '#FFFFFF',
            })}>
              {React.cloneElement(children, {
                closeModal: this.close,
              })}
            </div>
          </FocusTrap>
        </div>
      </div>
    );
  }
}

export default pure(ModalShell);



// WEBPACK FOOTER //
// ../src/client/components/modal/ModalShell.js